import { render, staticRenderFns } from "./Message.vue?vue&type=template&id=f062d634&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f062d634",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f062d634')) {
      api.createRecord('f062d634', component.options)
    } else {
      api.reload('f062d634', component.options)
    }
    module.hot.accept("./Message.vue?vue&type=template&id=f062d634&scoped=true", function () {
      api.rerender('f062d634', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/Message.vue"
export default component.exports